// src/components/NewLinkComponentForm.js
import React, { useState, useEffect } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage, auth } from '../firebaseConfig';

export default function NewLinkComponentForm({
                                                 title,
                                                 url,
                                                 onTitleChange,
                                                 onUrlChange,
                                                 onSubmit,
                                                 onCancel,
                                                 enablePublishButton = false,
                                                 onSubmitAndPublish
                                             }) {

        const [file, setFile] = useState(null);
        const [uploading, setUploading] = useState(false);

        const handleFileChange = e => {
                setFile(e.target.files?.[0] || null);
            };

      const handleSubmitAndPublish = async (e) => {
            e.preventDefault();
            let imageUrl = '';
            try {
                  if (file) {
                        setUploading(true);
                        const uid = auth.currentUser.uid;
                        const ts  = Date.now();
                        const storageRef = ref(storage, `linkImages/${uid}/${ts}_${file.name}`);
                        const uploadTask = uploadBytesResumable(storageRef, file);
                        await new Promise((res, rej) =>
                              uploadTask.on('state_changed', null, rej, res)
                            );
                        imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
                      }
                  onSubmitAndPublish?.(imageUrl);
                } finally {
                  setUploading(false);
                }
          };

        const handleSubmit = async e => {
                e.preventDefault();
                let imageUrl = '';
                if (file) {
                        setUploading(true);
                        const uid = auth.currentUser.uid;
                        const ts  = Date.now();
                        const storageRef = ref(storage, `linkImages/${uid}/${ts}_${file.name}`);
                        const uploadTask = uploadBytesResumable(storageRef, file);
                        await new Promise((res, rej) =>
                                uploadTask.on('state_changed', null, rej, res)
                            );
                        imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
                        setUploading(false);
                    }
                onSubmit(imageUrl);
            };


    return (
        <div className="new-component-form">
            <h1>Link Component Form</h1>
            <form className="new-component-form" onSubmit={handleSubmit}>

            <input
                type="text"
                placeholder="Link title"
                value={title}
                onChange={e=>onTitleChange(e.target.value)}
                className="muulti-input"
            />
            <input
                type="url"
                placeholder="https://example.com"
                value={url}
                onChange={e=>onUrlChange(e.target.value)}
                className="muulti-input"
            />
                            <label>
                                Optional Link Image:
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    className="muulti-input"
                                />
                            </label>

                        {uploading && <p>Uploading image…</p>}
            <div className="muulti-container-button-container">
                                <button type="submit" disabled={uploading} className="muulti-button">
                                    {uploading ? 'Uploading…' : 'Save Panel'}
                                </button>
                      {enablePublishButton && (
                        <button onClick={handleSubmitAndPublish} disabled={uploading} className="muulti-button">
                              {uploading ? 'Uploading…' : 'Save Panel & Publish'}
                            </button>
                      )}
                <button onClick={onCancel} className="muulti-button">Cancel</button>
            </div>
            </form>
        </div>
    );
}
